<ion-card class="app-background ion-padding">
  <ion-grid class="ion-padding">
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-label class="panel-header-text" color="dark">
          {{ 'register_createanaccount' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>

    <ion-row class="ion-margin-top">
      <ion-col size="12" class="ion-text-center">
        <ion-label color="dark">
          {{ 'register_ubieaccount' | translate }}
        </ion-label>
        <ion-item-divider class="ion-margin-top" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-margin-top">
      <ion-col size="12" class="ion-text-center">
        <ion-label class="panel-header-text" color="dark">
          {{ 'register_haveaccount' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>

    <ion-row class="ion-margin-top ion-justify-content-center">
      <ion-col size="10" size-sm="6">
        <ion-button expand="block" color="primary" (click)="userActionYes()">
          <small>{{ 'register_yes' | translate }}</small>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="10" size-sm="6">
        <ion-button expand="block" color="primary" (click)="userActionNo()">
          <small>{{ 'register_no' | translate }}</small>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-item-divider />
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
